import { serviceType } from '@/commonTypes';
import PageCard from '@/components/general/PageCard';
import DropDownCard from '@/components/pages/plates/MyPlatesContent/MyPlatesList/DropDownPlateCard/DropDownCard';
import React, { ReactNode, useState } from 'react';
import styles from '../styles.module.css';
import MainIcons from '@/icons/main';
import Button from '@/components/common/Button';
import { avatarBg } from '@/functions/formats';
import AiInsight from '../AiInsight';

interface historyType {
  id?: string | number;
  createdAt?: string;
  result?: serviceType | serviceType[];
  paymentId?: string | number;
}
export default function HistoryComponent({
  history,
  count = 0,
  children,
  className = '',
  getMoreHistory,
}: {
  history?: historyType[];
  count?: string | number;
  children?: ReactNode;
  className?: string;
  getMoreHistory?: () => void;
  getEachHistory?: () => void;
}) {
  const [expanded, setExpanded] = useState<number | null | string>();

  return (
    <div className={`${styles.pageCard} ${className} mt-18px`}>
      <DropDownCard
        className={`${styles.dropDown}`}
        open={expanded == 'history'}
        onToggle={() => {
          setExpanded(expanded == 'history' ? null : 'history');
        }}
        header={
          <PageCard
            title="تاریخچه استعلام‌ها"
            text="استعلام‌های گرفته شده شما"
            className={`${styles.historyHeader}`}
            icon={<MainIcons.clockIcon fill="var(--brand-deep)" />}
            backgroundIcon={avatarBg(6)}
          />
        }
        aside={<div className={`${styles.countHistory}`}>{count}</div>}
      >
        <div className={`${styles.historyList}`}>
          {children}
          {!history && <p className={`${styles.emptyList}`}>تاریخچه خالی است.</p>}
          {history && history?.length < Number(count) && (
            <Button
              wrapperStyle="mx-auto w-auto"
              className="btn btn-white squareButton mx-auto"
              onClick={getMoreHistory}
            >
              بیشتر
            </Button>
          )}
        </div>
      </DropDownCard>
    </div>
  );
}
